import { css } from '@emotion/react';
import { Button, useConfirmationDialog } from '@lbcamden/lib-react';
import { FunctionComponent } from 'react';

import { useHandlePinAuth } from '~/client/hooks/authHooks';

export const ResetPin: FunctionComponent = () => {
  const { resetUserPin } = useHandlePinAuth();

  const { confirmationDialog: resetPinDialog, show: showResetPinDialog } = useConfirmationDialog({
    css: (theme) => css`
      z-index: ${theme.zIndices.top + 2};
    `,
    title: 'Reset PIN',
    message:
      'Are you sure you want to reset your PIN? ' +
      'You will need to sign in with your Camden account first, ' +
      'so ensure you have a stable internet connection.',
    onConfirm: resetUserPin,
  });

  return (
    <>
      <Button $variant="tertiary" $color="primary" onClick={showResetPinDialog}>
        Reset PIN
      </Button>
      {resetPinDialog}
    </>
  );
};
